import { render, staticRenderFns } from "./BtnNewDemande.vue?vue&type=template&id=0074275f&scoped=true&"
import script from "./BtnNewDemande.vue?vue&type=script&lang=js&"
export * from "./BtnNewDemande.vue?vue&type=script&lang=js&"
import style0 from "./BtnNewDemande.vue?vue&type=style&index=0&id=0074275f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0074275f",
  null
  
)

export default component.exports